import React from 'react'
import { Spin } from 'antd';

interface Props {
    message?: string | React.ReactNode;
}

export const BusySpinner: React.FC<Props> = ({ message }) => {

    const coverStyle: React.CSSProperties = {
        zIndex: 2000,
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: '#ffffff72',
        textAlign: 'center',
        padding: 0,
        margin: 0
    };

    const spinnerStyle: React.CSSProperties = {
        position: 'relative',
        top: '50%',
        transform: "translate(0, -50%)",       
        background: '#ffffffaa',
        padding: '3em',
        borderRadius: '2em'
    };

    const spinnerWithMessageNodeStyle: React.CSSProperties = {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        top: '50%',
        left: '50%',
        transform: "translate(-50%, -50%)",
        background: '#ffffffaa',
        padding: '3em',
        borderRadius: '2em',
        width: '80%',
        minWidth: 400,
        maxWidth: 400
    }

    if (message && typeof message !== 'string') {
        return (
            <div style={coverStyle}>
                <div style={spinnerWithMessageNodeStyle}>
                    <Spin size="large" tip={typeof message === 'string' ? message : undefined} />
                    <div>{message}</div>
                </div>
            </div>
        );
    }

    return (
        <div style={coverStyle}>
            <Spin style={spinnerStyle} size="large" tip={typeof message === 'string' ? message : undefined} />
        </div>
    );
}

export default BusySpinner;